import { FlagIcon } from "react-flag-kit";
import { FaCheck } from "react-icons/fa6";
import { useTranslation } from "react-i18next";

import logoLingoPNG from "../../../assets/images/lingo_small.png";
import logoAndroidIosPNG from "../../../assets/images/icons/icon_ios_android.svg";

import {
  Container,
  HeaderCard,
  PlanName,
  WrapperLanguage,
  LogoLingo,
  DescriptionHeader,
  WrapperPriceCard,
  TextPriceCard,
  DescriptionCard,
  ItemDescriptionCard,
  Separator,
  WrapperLogoParther,
  WrapperPrice,
  TextPrice,
  WrapperLogoPartherHeader,
} from "./styles";

function CardInfo({ data, userInfo, partnersInfo, currencyURL }) {
  const { t } = useTranslation();
  const lang = localStorage.getItem("i18nextLng");

  const currency = userInfo?.country_code === "BR" || currencyURL === "BRL" ? "R$ " : "USD";
  const parts = data?.final_value?.toString()?.split(".") ?? "--";
  const cents = parts?.length > 1 ? parts[1] : "00";

  const itemDescriptionArray = [
    { id: "1", icon: <FaCheck size={20} color="#00c6ff" />, name: "ITEM_CARD_INFO1" },
    { id: "2", icon: <FaCheck size={20} color="#00c6ff" />, name: "ITEM_CARD_INFO2" },
    { id: "3", icon: <FaCheck size={20} color="#00c6ff" />, name: "ITEM_CARD_INFO3" },
    { id: "4", icon: <FaCheck size={20} color="#00c6ff" />, name: "ITEM_CARD_INFO4" },
    { id: "5", icon: <FaCheck size={20} color="#00c6ff" />, name: "ITEM_CARD_INFO5" },
    { id: "6", icon: <FaCheck size={20} color="#00c6ff" />, name: "ITEM_CARD_INFO6" },
    { id: "7", icon: <FaCheck size={20} color="#00c6ff" />, name: "ITEM_CARD_INFO7" },
  ];

  const handleTranslationNameDescription = (data, type) => {
    const english = lang === "en" || lang === "en-US";
    const portuguese = lang === "pt";
    const spanish = lang === "es";
    const french = lang === "fr";

    if (type === "name") {
      if (english) return data?.nameEnglish;
      else if (french) return data?.nameFrench;
      else if (spanish) return data?.nameSpanish;
      else if (portuguese) return data?.namePortuguese;
    } else if (type === "description") {
      if (english) return data?.descriptionEnglish;
      else if (french) return data?.descriptionFrench;
      else if (spanish) return data?.descriptionSpanish;
      else if (portuguese) return data?.descriptionPortuguese;
    }
  };

  return (
    <Container partner={data?.exclusiveFor === "partner" ? "true" : "false"}>
      <HeaderCard>
        <div>
          <div>
            <LogoLingo src={logoLingoPNG} alt="logo lingo" />
            <PlanName>{handleTranslationNameDescription(data, "name")}</PlanName>
          </div>

          <WrapperLanguage>
            <FlagIcon size={25} code="US" />
            <FlagIcon size={25} code="BR" />
            <FlagIcon size={25} code="ES" />
            <FlagIcon size={25} code="FR" />
          </WrapperLanguage>

          <DescriptionHeader>{handleTranslationNameDescription(data, "description")}</DescriptionHeader>
        </div>

        <WrapperPriceCard>
          <TextPriceCard>{t("TOTAL")}</TextPriceCard>

          <div>
            <sub>{currency}</sub>
            <span> {parts[0]}</span>
            <sub>,{cents} </sub>
            <sub>/{t("MONTH")}</sub>
          </div>
        </WrapperPriceCard>
      </HeaderCard>

      {data?.exclusiveFor === "partner" && partnersInfo && (
        <WrapperLogoPartherHeader>
          <img src={partnersInfo?.logo} />
        </WrapperLogoPartherHeader>
      )}

      <DescriptionCard>
        {itemDescriptionArray.map((item) => (
          <ItemDescriptionCard key={item.id}>
            <div>{item.icon}</div> <span>{t(item.name)}</span>
          </ItemDescriptionCard>
        ))}

        <ItemDescriptionCard>
          <div>
            <FaCheck size={20} color="#00c6ff" />
          </div>
          <span>{t("ITEM_CARD_INFO8")} </span>
          <img src={logoAndroidIosPNG} />
        </ItemDescriptionCard>
      </DescriptionCard>

      <Separator />

      {data?.exclusiveFor === "partner" && partnersInfo && (
        <>
          <WrapperLogoParther>
            <p>{t("A_PARTNER")}</p>
            <img src={partnersInfo?.logo} />
          </WrapperLogoParther>

          <Separator />
        </>
      )}

      <WrapperPrice>
        <TextPrice>{t("TOTAL")}</TextPrice>

        <div>
          <sub>{currency}</sub>
          <span> {parts[0]}</span>
          <sub>,{cents} </sub>
          <sub>/{t("MONTH")}</sub>
        </div>
      </WrapperPrice>
    </Container>
  );
}

export default CardInfo;
